/* eslint-disable global-require */
import { GetStaticPropsContext, NextPage } from 'next';

import { Locale } from '@silvertours/back-domain-sitegroup';
import { ErrorPageRequestHandler } from '@silvertours/back-runtime-landingpages';
import {
  ContentLayout,
  ErrorPageContent,
} from '@silvertours/common-landingpages-view';
import { LandingPageLegacy } from '@silvertours/front-pages';

const Error404: NextPage<ContentLayout<ErrorPageContent>> = page => (
  <LandingPageLegacy.ErrorPage {...page} />
);

export const getStaticProps = (context: GetStaticPropsContext) => {
  const handler = new ErrorPageRequestHandler(404, Locale.German.value);

  return handler.getStaticProps(context);
};

export default Error404;
